import { render } from "./OpenRhWebPayments.vue?vue&type=template&id=0ee84b23"
import script from "./OpenRhWebPayments.vue?vue&type=script&lang=js"
export * from "./OpenRhWebPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__